import React from 'react'

const Loading = () => {
  return (
    <img src="loding.png" alt="" className="w-48 animate-spin"/>
  )
}

export default Loading
